import React from 'react';
import PropTypes from 'prop-types';
import { connect } from "react-redux";

import ButtonFavorite from './ButtonFavorite';

function ConnectedRowSection({
  name, onClickTo, isFavorite = false, onClickFavorite, isSelected, style, className,
  isConnected, showIconFav = true
}) {
  return (
    <div className={`menu-left-container ${className} ${isSelected && `selected`}`} style={{ ...style }}>
      <div id={`ref-rp`} onClick={onClickTo} className={`flexRow align top-menu-container ${isSelected && `selected`}`}>
        <span className={`type-regular fz14 ellipsis`} style={{width: '92%'}}>{name}</span>
        { (isConnected && showIconFav) && <ButtonFavorite className={`icon-star ${isFavorite && `favorite`}`} color={'white'} size={17} active={isFavorite} onClick={onClickFavorite} /> }
      </div>
    </div>
  )
}

ConnectedRowSection.propTypes = {
  name: PropTypes.string.isRequired,
  to: PropTypes.string,
  onClickTo: PropTypes.func,
  isFavorite: PropTypes.bool,
  onClickFavorite: PropTypes.func,
  isSelected: PropTypes.bool,
  showIconFav: PropTypes.bool,
  style: PropTypes.object,
}

const RowSection = connect(
  state => ({
    isConnected: state.isConnected
  })
)(ConnectedRowSection);

export default RowSection;
